import { combineReducers } from "redux";
import userProjectReducer from "../userPojectSlice/userProjectSlice";
import chartReducer from "../chartSlice/chartSlice"
import dateCompareReducer from "../dateCompareSlice/dateCompareSlice";
import filterReducer from "../filterSlice/filterSlice"; 
import brandPerformanceChartReducer from "../brandPerformanceChartSlice/brandPerformanceChartSlice";
import allMarketReducer from "../handleAllMarket/handleAllMarket";
import twoColumnChartReducer from "../twoColumnChartSlice/twoColumnChartSlice";
import twoColumnChartVolumeReducer from "../twoColumnChartSlice/twoColumnChartVolumeSlice";
import promoSimulatorReducer from "../promoSimulatorSlice/promoSimulatorSlice";

const rootReducer = combineReducers({
    userProject: userProjectReducer,
    chart: chartReducer,
    dateCompare: dateCompareReducer,
    filter: filterReducer, 
    brandPerformanceChart :brandPerformanceChartReducer,
    allMarket: allMarketReducer,
    twoColumnChart: twoColumnChartReducer,
    twoColumnChartVolume: twoColumnChartVolumeReducer,
    promoSimulator: promoSimulatorReducer,

    // Add other reducers here if needed
  });


  export default rootReducer;
  

  